import { RootStore } from "./rootStore";
import { makeAutoObservable, observable, action, runInAction } from "mobx";
import agent from "../api/agent";
import { toast } from "react-toastify";
import { IBroker, INotificationSignature } from "../models/company";
import { showError } from "../util/errorTypeEnumsOptions";

export default class CompanyStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  @observable loadBroker = false;
  @observable btSignature = false;

  //ojo este broker es el dem market se utiliza para la sesion
  @observable broker: IBroker | null = null;
  @observable btUploadLogo = false;
  @observable image: string | null = null;

  @action changeStatebtUploadLogo = () => {
    this.btUploadLogo = !this.btUploadLogo;
  };

  @action changeStatebtSignature = () => {
    this.btSignature = !this.btSignature;
  };

  @action changeStateloadBroker = () => {
    this.loadBroker = !this.loadBroker;
  };

  @action getBroker = async () => {
    try {
      const company = await agent.Company.getBroker(
        window.localStorage.getItem("jwtGeneral")
      );
      runInAction(() => {
        this.broker = company.data;
        if (this.image == null) {
          this.getImage();
        }
        this.loadBroker = true;
      });
    } catch (error) {
      console.error(error);
    }
  };

  @action patchSignature = async (signature: INotificationSignature) => {
    this.changeStatebtSignature();
    try {
      const res = await agent.Company.patchSignature(signature);
      toast.success("La firma se ha guardado correctamente");
      runInAction(() => {
        this.broker.signature = signature.signature;        
      });
    } catch (error) {
      showError(error);
    }
    this.changeStatebtSignature();
   
  };

  @action uploadLogo = async (logo: Blob) => {
    if (logo != null) {
      try {
        this.changeStatebtUploadLogo();
        const res = await agent.Company.uploadLogo(logo);
        runInAction(() => {
          this.broker = res;
          this.changeStatebtUploadLogo();
          toast.success("El logo se ha guardado correctamente");
          this.getImage();
        });
      } catch (error) {
        showError(error);
        this.changeStatebtUploadLogo();
      }
    } else toast.error("Debe seleccionar una imagen");
  };
  @action getImage = async () => {
    if (this.broker?.logoUrl != null) {
        let url = this.broker?.logoUrl || "";
        var myRequest = new Request(url);
        fetch(myRequest).then((response) => {
          response.blob().then((blob) => {
            const reader = new FileReader();
            reader.addEventListener("loadend", (event) => {
              var text = event.target?.result;
              runInAction(() => {
                this.image = "data:image/png;base64," + text;
              });
            });
            reader.readAsText(blob);
          });
        })
        .catch (() => {});
    }
  };
}
